var map = {
	"./hotelRoom0.jpg": 2783,
	"./hotelRoom1.jpg": 7736,
	"./hotelRoom2.jpg": 4089,
	"./hotelRoom3.jpg": 5186,
	"./hotelRoom4.jpg": 9279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8889;